import { inject, Injectable } from "@angular/core";
import { firstValueFrom, Observable } from "rxjs";
import { VkKartaLayerNames } from "~app/common/models/constants";
import { ApiClientService } from "~app/common/services/api-client.service";
import { environment } from "~environments/environment";
import { SaveVirkeskopsKontraktDokumentDTO } from "../dto/dokument/SaveVirkeskopsKontraktDokumentDTO";
import { VirkeskopDokumentInfoDTO } from "../dto/dokument/VirkeskopDokumentInfoDTO";
import { VirkeskopRitunderlagKoordinaterDTO } from "../dto/dokument/VirkeskopRitunderlagKoordinaterDTO";

@Injectable({
    providedIn: "root"
})

export class KontraktRitunderlagService {
    private readonly apiClient = inject(ApiClientService);

    async getRitunderlagKoordinater(dokumentId: number): Promise<VirkeskopRitunderlagKoordinaterDTO> {
        return firstValueFrom(this.apiClient.get(`virkeskop/ritunderlag/koordinater?id=${encodeURIComponent(dokumentId)}`));
    }

    getRitunderlagUrl(dokumentId: number): string {
        return `${environment.apiV2}/virkeskop/ritunderlag?id=${encodeURIComponent(dokumentId)}`;
    }

    getRitunderlagTitel(filnamn) {
        if (filnamn) {
            return filnamn.replace(/^.*[\\/]/, "");
        }

        return filnamn;
    }

    getLagerId(dokumentId: number, baseLayer: string = VkKartaLayerNames.ritunderlagLayer): string {
        return `${baseLayer}-${dokumentId}`;
    }

    uploadDokument(kontraktId: number, dokument: SaveVirkeskopsKontraktDokumentDTO): Observable<VirkeskopDokumentInfoDTO> {
        return this.apiClient.post<SaveVirkeskopsKontraktDokumentDTO, VirkeskopDokumentInfoDTO>(`virkeskop/${kontraktId}/ritunderlag`, dokument);
    }

    async deleteDokument(dokumentId: number): Promise<boolean> {
        return firstValueFrom(this.apiClient.delete(`virkeskop/ritunderlag?id=${encodeURIComponent(dokumentId)}`));
    }
}
